import type * as React from 'react'

import type { Image } from '~publish/legacy/composer/composer/entities/factories'

import styles from './ImagesCarousel.module.css'

export const ImagesCarousel = ({
  images,
  maxHeight = '300px',
  className,
}: {
  images: Image[]
  maxHeight?: string
  className?: string
}): React.ReactElement => {
  if (!Array.isArray(images) || images.length <= 0) {
    return <></>
  }

  return (
    <div
      data-testid="preview-images"
      className={className}
      style={{ height: maxHeight || '300px' }}
    >
      <div className={styles.carouselContainer}>
        <div className={styles.carouselWrapper}>
          {images.map((image, index) => (
            <img
              className={styles.carouselImage}
              key={image.url}
              src={image.url}
              alt={`Slide ${index}`}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
